import { render } from "./Bevindingen.vue?vue&type=template&id=ce0fb216"
import script from "./Bevindingen.vue?vue&type=script&lang=js"
export * from "./Bevindingen.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Projects\\Vind\\Vind\\VindFront\\VindFrontVueApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QSplitter from 'quasar/src/components/splitter/QSplitter.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QTabs from 'quasar/src/components/tabs/QTabs.js';
import QTab from 'quasar/src/components/tabs/QTab.js';
import QTabPanels from 'quasar/src/components/tab-panels/QTabPanels.js';
import QTabPanel from 'quasar/src/components/tab-panels/QTabPanel.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';
import QDate from 'quasar/src/components/date/QDate.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTd from 'quasar/src/components/table/QTd.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSplitter,QAvatar,QTabs,QTab,QTabPanels,QTabPanel,QSelect,QInput,QIcon,QPopupProxy,QDate,QBtn,QTable,QTr,QTd});qInstall(script, 'directives', {ClosePopup});
